import HomePage from '../views/HomePage';
import AboutPage from '../views/AboutPage';
import TherapiesServices from '../views/TheraputicServices';
import OurTeamPage from '../views/OurTeamPage';
import ResourcesPage from '../views/ResourcesPages';
import ContactPage from '../views/ContactPage';
import YourAppointmentPage from '../views/YourAppointment';
import OccupationalTherapyPage from '../views/OccupationalTherapyPage';
import AboutUsCommunityImpactPage from '../views/AboutUsCommunityImpactPage';
import FormPage from '../views/FormPage';
import PhysicalTherapyPage from '../views/PhysicalTherapyPage';
import TelehealthPage from '../views/TelehealthPage';
import SpeechTherapyPage from '../views/SpeechTherapyPage';
import EducationalPage from '../views/EducationalPage';
import BehavioralHealth from '../views/BehavioralHealth';
import DyslexiaPage from '../views/DyslexiaPage';

const PageRoutes = (locationKey) => [
  {
    path: '/',
    element: <HomePage />,
    title:
      "Children's Physical, Occupational & Speech Therapy in Alaska | Guidepost Pediatrics",
  },
  {
    path: '/our-team',
    element: <OurTeamPage />,
    title: 'Guidepost - Our Team',
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
    title: 'Guidepost - Resources',
  },
  {
    path: '/resources/forms',
    element: <FormPage />,
    title: 'Guidepost - Forms',
  },
  { path: '/contact', element: <ContactPage />, title: 'Guidepost - Contact' },
  {
    path: '/appointment',
    element: <YourAppointmentPage key={locationKey} />,
    title: 'Guidepost - Appointment',
  },
  { path: '/about', element: <AboutPage />, title: 'Guidepost - About Us' },
  {
    path: '/about/community-impact',
    element: <AboutUsCommunityImpactPage />,
    title: 'Guidepost - Community Impact',
  },
  {
    path: '/services',
    element: <TherapiesServices />,
    title: 'Guidepost - Our Services',
  },
  {
    path: '/services/physical-therapy',
    element: <PhysicalTherapyPage />,
    title: 'Guidepost - Physical Therapy',
  },
  {
    path: '/services/occupational-therapy',
    element: <OccupationalTherapyPage />,
    title: 'Guidepost - Occupational Therapy',
  },
  {
    path: '/services/speech-therapy',
    element: <SpeechTherapyPage />,
    title: 'Guidepost - Speech Therapy',
  },
  {
    path: '/services/educational-service',
    element: <EducationalPage />,
    title: 'Guidepost - Educational Therapy',
  },
  {
    path: '/services/telehealth',
    element: <TelehealthPage />,
    title: 'Guidepost - Telehealth',
  },
  {
    path: '/services/behavioral-health',
    element: <BehavioralHealth />,
    title: 'Guidepost - Behavioral Health',
  },
  {
    path: '/services/dyslexia',
    element: <DyslexiaPage />,
    title: 'Guidepost - Dyslexia',
  },
];

export default PageRoutes;
